//import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
//import { Component } from 'react';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { CCTMovimientoConsultaFormValues } from '../models/CCTMovimientoConsulta';
import { CCTMovimientoReportes } from '../models/CCTMovimientoReporte';
//import { CCTOperacion, CCTOperacionesFormValues } from '../models/CCTOperacion';
//import { store } from './store';
import { jsPDF } from "jspdf";
//import { FcPieChart } from 'react-icons/fc';

export default class CCTMovimientoReporteStore {
    CCTMovimientoRegistry = new Map<any, CCTMovimientoReportes>();


    selectedCCTMovimiento: CCTMovimientoReportes | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""
    dataMessage = false

    constructor() {
        makeAutoObservable(this)
    }

    get CCTMovimientoByCodigo() {
        return Array.from(this.CCTMovimientoRegistry.values());
    }

    get groupedCCTMovimientos() {
        return this.CCTMovimientoRegistry
    }

    loadCCTMovimiento = async (CCTMovimiento: CCTMovimientoConsultaFormValues) => {
        let CCTMovimientoReportes = this.getCCTMovimiento(CCTMovimiento);
        this.CCTMovimientoRegistry.clear()
        if (CCTMovimientoReportes) {
            this.CCTMovimientoRegistry.clear()
            this.selectedCCTMovimiento = CCTMovimientoReportes;
            return CCTMovimientoReportes;
        } else {
            this.loadingInitial = true;
            try {
                this.CCTMovimientoRegistry.clear()
                const CCTOperaciones: CCTMovimientoReportes[] =  await agent.CCTOperaciones.report(CCTMovimiento);
                CCTOperaciones.forEach(element => {
                    this.setCCTMovimiento(element);
                })
                runInAction(() => {
                    this.selectedCCTMovimiento = CCTMovimientoReportes || this.selectedCCTMovimiento;
                })
                this.setLoadingInitial(false);
                return CCTMovimientoReportes;
            } catch (error) {
                this.setLoadingInitial(false);
            }
        }
    }

    loadCCTMovimientoR = async (CCTMovimiento: CCTMovimientoConsultaFormValues) => {
        this.dataMessage = false
        let CCTMovimientoReportes = this.getCCTMovimiento(CCTMovimiento);
        this.CCTMovimientoRegistry.clear()
        if (CCTMovimientoReportes) {
            this.CCTMovimientoRegistry.clear()
            this.selectedCCTMovimiento = CCTMovimientoReportes;
            return CCTMovimientoReportes;
        } else {
            this.loadingInitial = true;
            try {
                this.CCTMovimientoRegistry.clear()
                const CCTOperaciones: CCTMovimientoReportes[] =  await agent.CCTOperaciones.report(CCTMovimiento);
                CCTOperaciones.forEach(element => {
                    this.setCCTMovimiento(element);
                })
                runInAction(() => {
                    this.selectedCCTMovimiento = CCTMovimientoReportes || this.selectedCCTMovimiento;
                })
                this.setLoadingInitial(false);
                this.CCTMovimientoByCodigo.map((item) => {
                    item.cuentas.map((item2) => {
                        if(item2.tipo === "Sin registros"){
                            this.dataMessage = true
                            toast.error("No hay movimientos")
                        }else{
                            this.dataMessage = false
                            this.reporte(this.CCTMovimientoByCodigo);
                        }
                    })
                })
                return CCTMovimientoReportes;
            } catch (error) {
                this.setLoadingInitial(false);
            }
        }
    }

    private setCCTMovimiento = (data: CCTMovimientoReportes) => {
        this.CCTMovimientoRegistry.set(data.fechaInicial, data);
    }

    private getCCTMovimiento = (CCTMovimiento: any) => {
        return this.CCTMovimientoRegistry.get(CCTMovimiento);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    updateCCTMovimiento = async (id: any, estatus: any, CCTMovimientoReportes: CCTMovimientoReportes) => {
        try {
            await agent.CCTOperaciones.update(id, estatus);
            runInAction(() => {
                if (CCTMovimientoReportes.fechaInicial) {
                    let updateCCTMovimiento = {...this.getCCTMovimiento(CCTMovimientoReportes.fechaInicial), ...CCTMovimientoReportes}
                    this.CCTMovimientoRegistry.set(CCTMovimientoReportes.fechaInicial, updateCCTMovimiento as CCTMovimientoReportes);
                    this.selectedCCTMovimiento = updateCCTMovimiento as CCTMovimientoReportes
                    this.loading = false;
                }
                    
            } )
            // runInAction(() => {
            //     if (CCTMovimientoReportes) {
            //         let updateCCTMovimiento = {...this.getCCTMovimiento(CCTMovimientoReportes), ...CCTMovimientoReportes}
            //         this.CCTMovimientoRegistry.set(CCTMovimientoReportes.id, updateCCTMovimiento as CCTMovimientoReportes);
            //         this.selectedCCTMovimiento = updateCCTMovimiento as CCTMovimientoReportes
            //         this.loading = false;
            //     }
                   
            // } )
        } catch (error) {
        }
    }

    reporte(CCTMovimientoReportes: any){
        const nf = new Intl.NumberFormat("es-MX"); 
        const nf1 = new Intl.NumberFormat("es-MX");
        //let contador_paginas = 1
        let contador_lineas = 30
        const doc = new jsPDF();
        doc.setFontSize(20);
        doc.text("INAP", 10, 10);
        doc.setFontSize(13);
        doc.text("Reporte de Movimientos", 10, 20);
        {CCTMovimientoReportes.map((cuentas:any) =>{
            var fecha_Movimiento = cuentas.fechaInicial.split("-", 3)
            var dia = fecha_Movimiento[2].split("T", 2)
            doc.text("Del: ", 165, 10)
            doc.text(dia[0] + "/" + fecha_Movimiento[1] + "/" + fecha_Movimiento[0], 175,10)
            if(cuentas.fechaFinal){
                var fecha_Movimiento = cuentas.fechaFinal.split("-", 3)
                var dia = fecha_Movimiento[2].split("T", 2)
                doc.text("Al: ", 165, 20)
                doc.text(dia[0] + "/" + fecha_Movimiento[1] + "/" + fecha_Movimiento[0], 175,20)
            }
            {cuentas.cuentas.map((cuenta:any) => {
                doc.setFontSize(10);
                doc.setTextColor(9, 13, 7);
                doc.text("Tipo de Cuenta: " + cuenta.tipo, 10, contador_lineas)
                contador_lineas = contador_lineas + 4
                {cuenta.transacciones.map((transaccion:any) => {
                    doc.setFontSize(9);
                    doc.setTextColor(9, 13, 7);
                    var total_formato = nf1.format(transaccion.total)
                    if((transaccion.total % 1) == 0){
                        total_formato = total_formato + ".00"
                    }
                    doc.text("Tipo de Movimiento: " + transaccion.tipo, 15, contador_lineas + 6)
                    contador_lineas = contador_lineas + 12
                    doc.text("Fecha", 22, contador_lineas)
                    doc.text("DPI", 45, contador_lineas)
                    doc.text("Nombre", 80, contador_lineas)
                    doc.text("Descripcion", 124, contador_lineas)
                    doc.text("Credito", 155, contador_lineas)
                    doc.text("Debito", 175, contador_lineas)
                    doc.setLineWidth(0.5); 
                    doc.line(15, contador_lineas + 2, 190, contador_lineas + 2);
                    contador_lineas = contador_lineas + 6
                    if(contador_lineas >= 285){
                        doc.addPage()
                        contador_lineas = 10
                    }
                    {transaccion.movimientos.map((movimiento:any) => {
                        doc.setFontSize(8);
                        doc.setTextColor(96, 96, 96 );
                        var nombre = movimiento.nombre.substr(0, 27)
                        doc.text(movimiento.fecha + "    " + movimiento.dpi + "    " + nombre + "...", 20, contador_lineas)
                        var descripcion = movimiento.descripcion.substr(0,20)
                        doc.text(descripcion + "...", 115, contador_lineas)
                        if(movimiento.codigoOperacion == "1"){
                            var valor_formato = nf.format(movimiento.valor)
                            if((movimiento.valor % 1) == 0){
                                valor_formato = valor_formato + ".00"
                            }
                            doc.text(valor_formato, 165, contador_lineas, {align: 'right'})
                            doc.text("0.00", 185, contador_lineas, {align: 'right'})
                        }else if(movimiento.codigoOperacion == "-1"){
                            var valor_formato = nf.format(movimiento.valor)
                            if((movimiento.valor % 1) == 0){
                                valor_formato = valor_formato + ".00"
                            }
                            doc.text(valor_formato, 185, contador_lineas, {align: 'right'})
                            doc.text("0.00", 165, contador_lineas, {align: 'right'})
                        }
                        // doc.text(movimiento.valor, 200, contador_lineas)
                        contador_lineas = contador_lineas + 4
                        if(contador_lineas >= 285){
                            doc.addPage()
                            contador_lineas = 10
                        } 
                    })}
                    doc.text(total_formato, 150, contador_lineas + 2)
                })}
                doc.setFontSize(10);
                doc.setTextColor(9, 13, 7);
                var total_formato_cuenta = nf1.format(cuenta.total)
                if((cuenta.total % 1) == 0){
                    total_formato_cuenta = total_formato_cuenta + ".00"
                }
                doc.text("Total: " + total_formato_cuenta, 150, contador_lineas + 10)
            })}
        })}
        // doc.text(CCTMovimientoReportes.fechaInicial, 115, 20)
        // doc.save("REPORTE_DE_MOVIMIENTOS.pdf");
        window.open(URL.createObjectURL(doc.output("blob")));
    }

}